import React from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product, onEdit, onDelete }) => {

  const getProductImage = () => {
    if (product.displayImage) return product.displayImage.startsWith('http') ? product.displayImage : `http://localhost:5000/${product.displayImage.replace(/\\/g, '/')}`;
    if (product.files?.length > 0) return product.files[0].startsWith('http') ? product.files[0] : `http://localhost:5000/${product.files[0].replace(/\\/g, '/')}`;
    return "https://via.placeholder.com/300x200?text=No+Image";
  };

  return (
    <div className="col-md-3 col-sm-6 mb-4">
      <div className="card h-100 overflow-hidden group-hover">
        {/* IMAGE */}
        <Link to={`/products/${product._id}`} className="d-block bg-light" style={{ height: '180px' }}>
          <img 
            src={getProductImage()} 
            className="w-100 h-100" 
            alt={product.model} 
            style={{ objectFit: 'contain', padding: '15px' }} 
          />
        </Link>

        {/* BODY */}
        <div className="card-body">
          <Link to={`/products/${product._id}`} className="text-dark fw-bold text-decoration-none">
            <h6 className="card-title text-truncate mb-1">{product.model}</h6>
          </Link>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <span className="badge bg-light text-dark border">{product.storage || 'N/A'}</span>
            <span className="fw-bold text-primary">₹{product.price}</span>
          </div>
        </div>

        {/* FOOTER */}
        <div className="card-footer bg-white border-top-0 d-flex gap-2 pt-0 pb-3">
          <button className="btn btn-sm btn-outline-warning w-50" onClick={(e) => { e.preventDefault(); onEdit(product); }}>
            <i className="bi bi-pencil"></i> Edit
          </button>
          <button className="btn btn-sm btn-outline-danger w-50" onClick={(e) => { e.preventDefault(); onDelete(product._id); }}>
            <i className="bi bi-trash"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;